<template>
  <div class="card h-dvh">
    <div class="absolute top-3 right-3 flex gap-2">
      <HomeButton class="text-color-primary w-6 h-6" />
      <ThemeToggleButton class="text-color-primary w-6 h-6" />
    </div>
    <Splitter
      class="h-full"
      layout="vertical"
      :gutter-size="3"
      :pt="{ gutterHandle: { style: 'background: var(--p-surface-500);' } }"
    >
      <SplitterPanel :size="40" class="flex items-center justify-center">
        <CytoGraph />
      </SplitterPanel>
      <SplitterPanel>
        <InformationPane
          v-model="queryStore.tabValue"
          class="h-full flex flex-col"
        />
      </SplitterPanel>
    </Splitter>
  </div>
</template>

<script setup>
import Splitter from "primevue/splitter";
import SplitterPanel from "primevue/splitterpanel";
import CytoGraph from "@/components/cyto_graph_components/CytoGraph.vue";
import InformationPane from "@/components/InformationPane.vue";
import HomeButton from "@/components/HomeButton.vue";
import ThemeToggleButton from "@/components/ThemeToggleButton.vue";
import { useQueryStore } from "@/stores/queryStore.js";

const queryStore = useQueryStore();
</script>

<style></style>
